import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  data: []
}

export const bannerSlice = createSlice({
  name: 'bannerSliceName',
  initialState,
  reducers: {
    addBanner: (state) => {
      state.loading = true;
    },
    getBanner: (state) => {
      state.loading = true;
    },
    getOneBanner: (state) => {
      state.loading = true;
    },

    successBanner: (state, action) => {
      // If the payload comes from the new backend structure { success: true, data: [...] }
      if (action.payload && action.payload.data && Array.isArray(action.payload.data)) {
        state.data = action.payload.data;
      } else if (action.payload && Array.isArray(action.payload)) {
        // Fallback for old/other endpoints returning raw array
        state.data = action.payload;
      } else {
        // Handle single object response (for getOneBanner)
        state.data = action.payload && action.payload.data ? action.payload.data : action.payload;
      }
      state.loading = false;
      state.error = null;
    },
    removeBanner: (state) => {
      state.loading = true;
    },
    updateBanner: (state) => {
      state.loading = true;
    },
  },
})

// Action creators are generated for each case reducer function
export const { addBanner, removeBanner, updateBanner, getBanner, successBanner, getOneBanner } = bannerSlice.actions

export default bannerSlice.reducer